import { overlay, paymentmethod, paymenterror, details, share, payment, paymentresult, paymenticon, accountpayment, terms, paypalpayment, giftwindow, giftpayment, giftcontainer, giftresult, agreement, gifticon, editProfile, editAddress, editPassword, editEmail, editUsername, viewOptionBlock, viewSwitch, viewOptionList, viewDetails, viewFade, viewOwner, viewIcons, viewIconicText, viewBeta, viewOption, viewDesc, viewInfo, viewInfoItem, viewInfoText, taglineSpan, taglineField, viewItems, gamecopies, newsWindow }  from '../animations.overlay';
import { Component, EventEmitter, Query, ViewChild, Output, Input, ViewChildren, ContentChildren, Directive, ElementRef, QueryList, OnInit, trigger, state, animate, style, transition, keyframes, group } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';
import { featuresBox, featureslist }  from '../animations.panels';
import { Router, ActivatedRoute } from '@angular/router';
import { Http, Response, Headers } from '@angular/http';
import { AppComponent } from '../../app.component';
import { UserService } from '../../services/user.service';
import { StoreService } from '../../services/store.service';
import { environment } from '../../environment';

// Products
import { Item } from '../../models/item';
import { Product } from '../../models/product';
import { News } from '../../models/news';
import { Account } from '../../models/account';
import { Character } from '../../models/character';
import { DiscordUser, DiscordMessage, DiscordRoles } from '../../models/discord';


declare var $: any

@Component({
  selector: 'user-discord',
  templateUrl: './user.discord.html',
  providers: [ UserService ],
  animations: [ featuresBox, featureslist, featuresBox, overlay, paymentmethod, paymenterror, details, share, payment, paymentresult, paymenticon, accountpayment, terms, paypalpayment, giftwindow, giftpayment, giftcontainer, giftresult, agreement, gifticon, editProfile, editAddress, editPassword, editEmail, editUsername, viewOptionBlock, viewOptionList, viewDetails, viewSwitch, viewFade, viewOwner, viewIcons, viewIconicText, viewBeta, viewOption, viewDesc, viewInfo, viewInfoItem, viewInfoText, taglineSpan, taglineField, viewItems, gamecopies, newsWindow ]
})
export class DiscordComponent implements OnInit {

	/* Header Tokens */
	public token: any;

	/* Models */
	title: string;
	subtitle: string;

	users: DiscordUser;
	roles: DiscordRoles;
	messages: DiscordMessage;
	compose = new Composition();

	constructor(private http : Http,
				private user: UserService,
				private store: StoreService,
				private router: Router,
				private route: ActivatedRoute,
				private sanitizer: DomSanitizer) { }

	getAvatar(user) {
		let url = '';
		if( user.user_id && user.avatar) {
			url = 'https://media.discordapp.net/avatars/'+user.user_id+'/'+user.avatar+'.jpg';
		} else{ 
			url = '/assets/img/identity_head.png';
		}
		return url;
	}

	fetchMessages() {
		setTimeout( () => {
			Promise.resolve( this.user.getDiscordMessages() ).then( (msg) => {
				this.messages = msg;
			});
		}, 1200);
	}

	fetchUsers() {
		setTimeout( () => {
			Promise.resolve( this.user.getDiscordUsers() ).then( (user) => {
				this.users = user;
			});
			Promise.resolve( this.user.getDiscordRoles() ).then( (role) => {
				this.roles = role;
			});
		}, 3500);
	}

	composeKey( e ) {
		if ( e.code == "Enter" ) {
			Promise.resolve( this.user.sendDiscordMessage(this.compose.body) ).then( (usr) => {
				// console.log(usr);
				this.compose.body = '';
			});
		}
	}

	ngOnInit() {
		this.fetchMessages();
		this.fetchUsers();
		this.title = 'Hello';
	}
}

export class Composition {
	constructor(
		public body?: any
	) {}
}


// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/user/user-discord/user.discord.component.ts